import {gql} from "@apollo/client";
import {Brand} from "@App/types";

export interface VehicletreeQuery {
    brands: Brand[]
}

export const GET_VEHICLETREE = gql`
    query getVehicletree($brandId: ID, $generationId: ID, $motorizationId: ID, $brandSlug: String, $generationSlug: String, $motorizationSlug: String, $includeGenerations: Boolean!, $includeMotorizations: Boolean!, $hasMaintenance: Boolean, $hasTimes: Boolean, $organization: ID) {
        brands(id: $brandId, slug: $brandSlug, organization: $organization) {
            id
            name
            logo
            slug
            important
            generations(id: $generationId, slug: $generationSlug, hasMaintenance: $hasMaintenance, hasTimes: $hasTimes) @include(if: $includeGenerations) {
                id
                name
                slug
                built_from
                motorizations(id: $motorizationId, slug: $motorizationSlug, hasMaintenance: $hasMaintenance, hasTimes: $hasTimes) @include(if: $includeMotorizations) {
                    id
                    name
                    slug
                    built_from
                    built_to
                    kw
                    ps
                    displacement
                    bodies {
                        id
                        name
                    }
                    fuelType {
                        id
                        name
                    }
                    gearboxes {
                        id
                        name
                        formatted_name
                    }
                }
            }
        }
    }
`;
